import { comoDataTypes } from "redux/reducers/comoData/comoDataTypes";
import { api_put, api_delete, api_post, api_get } from "services/api";
import { startRequestComp, stopRequestComp, setSnackbar } from "../search/searchActions";

const {
  SET_COMO_DATA_FILTERS,
  COMO_DATA_SELECTED,
  EDIT_COMO_DATA_MODE,
  ADD_COMO_DATA_MODE,
  DELETE_COMO_DATA_MODE,
  GET_COMO_DATA,
  CREATE_COMO_DATA,
  MOD_COMO_DATA,
  DELETE_COMO_DATA,
  RESET_COMO_DATA_SELECTED,
  CLEAR_COMO_DATA,
  SET_CONFIG_FILTER_COMO_DATA,
  SET_CONFIG_PAGE_COMO_DATA,
  SET_CONFIG_PAGE_SIZE_COMO_DATA,
  SET_CONFIG_SORTED_COMO_DATA,
  CLEAN_COMO_DATA,
} = comoDataTypes

export const getAllComoData = () => {
  const url = `${process.env.REACT_APP_URL}/crm/commodatos`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingComoData'))

    await api_get(url).then(resp => {
      dispatch({
        type: GET_COMO_DATA,
        payload: resp
      })
    }).catch(error => {
      dispatch(setSnackbar(error))
    })
    dispatch(stopRequestComp('loadingComoData'))
  }
}

export const getComoData = (stationID) => {
  const url = `${process.env.REACT_APP_URL}/crm/commodatos/by-station/${stationID}`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingComoData'))

    await api_get(url).then(resp => {
      dispatch({
        type: GET_COMO_DATA,
        payload: resp
      })
    }).catch(error => {
      dispatch(setSnackbar(error))
      dispatch({
        type: CLEAN_COMO_DATA,
      })
    })
    dispatch(stopRequestComp('loadingComoData'))
  }
}

export const comoDataSelected = (id) => {
  return {
    type: COMO_DATA_SELECTED,
    payload: id
  }
}

export const addComoDataMode = () => {
  return {
    type: ADD_COMO_DATA_MODE,
  }
}

export const editComoDataMode = () => {
  return {
    type: EDIT_COMO_DATA_MODE,
  }
}

export const deleteComoDataMode = () => {
  return {
    type: DELETE_COMO_DATA_MODE,
  }
}

export const resetComoDataSelected = () => {
  return {
    type: RESET_COMO_DATA_SELECTED
  }
}
export const createNewComoData = (form, evidence, contract, onClose = null) => {
  const url = `${process.env.REACT_APP_URL}/crm/commodatos`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingComoData'))

    await api_post(url, form).then(resp => {
      dispatch({
        type: CREATE_COMO_DATA,
        payload: resp
      })
      dispatch(setSnackbar('Creado con éxito', 'success'))
      if (evidence) dispatch(postEvidenceFiles(evidence, resp.id))
      if (contract) dispatch(postContractFile(contract, resp.id))
      onClose && onClose()
    }).catch(error => {
      dispatch(setSnackbar(error))
    })

    dispatch(stopRequestComp('loadingComoData'))
  }
}

export const postEvidenceFiles = (files, id) => {
  const url = `${process.env.REACT_APP_URL}/crm/commodatos/${id}/upload-evidence`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingComoData'))
    try {
      files.map(async (file) => {
        const formData = new FormData();
        formData.append("evidence", file, file.name);
        const resp = await api_post(url, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        dispatch({
          type: MOD_COMO_DATA,
          payload: resp
        })
      });

    } catch (error) {
      dispatch(setSnackbar(error))
    }
    dispatch(stopRequestComp('loadingComoData'))
  };
};

export const postContractFile = (file, id) => {
  const url = `${process.env.REACT_APP_URL}/crm/commodatos/${id}/upload-contract`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingComoData'))
    try {
      const formData = new FormData();
      formData.append("contract", file, file.name);
      const resp = await api_post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      dispatch({
        type: MOD_COMO_DATA,
        payload: resp
      })
    } catch (error) {
      dispatch(setSnackbar(error))
    }
    dispatch(stopRequestComp('loadingComoData'))
  };
};

export const editComoData = (comoDataSelected, form, contract, evidence, deletedEvidenceIds = [], onClose = null) => {
  const url = `${process.env.REACT_APP_URL}/crm/commodatos/${comoDataSelected.id}`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingComoData'))

    await api_put(url, form).then(async resp => {
      dispatch({
        type: MOD_COMO_DATA,
        payload: resp
      })
      if (comoDataSelected.contract !== contract) {
        await dispatch(deleteContract(comoDataSelected.id))
        dispatch(postContractFile(contract, comoDataSelected.id))
      }
      
      const deletePromises = deletedEvidenceIds.map(idEvidence =>
        dispatch(deleteEvidence(comoDataSelected.id, idEvidence))
      );
      await Promise.all(deletePromises)
      const newFiles = evidence.filter(file => !file?.id)
      if (newFiles.length) {
        await dispatch(postEvidenceFiles(newFiles, comoDataSelected.id))
      }
      dispatch(setSnackbar('Actualizado correctamente', 'success'))
      onClose && onClose()
    }).catch(error => {
      dispatch(setSnackbar(error))
    })
    dispatch(stopRequestComp('loadingComoData'))
  }
}

export const deleteContract = (id) => {
  const url = `${process.env.REACT_APP_URL}/crm/commodatos/${id}/remove-contract`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingComoData'))
    await api_post(url).then(resp => {
      dispatch({
        type: MOD_COMO_DATA,
        payload: resp
      })
      dispatch(setSnackbar('Eliminado correctamente', 'success'))
    }).catch(error => {
      dispatch(setSnackbar(error))
    })
    dispatch(stopRequestComp('loadingComoData'))
  }
}

export const deleteEvidence = (id, idEvidence) => {
  const url = `${process.env.REACT_APP_URL}/crm/commodatos/${id}/remove-evidence/${idEvidence}`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingComoData'))

    await api_post(url).then(resp => {
      dispatch({
        type: MOD_COMO_DATA,
        payload: resp
      })
      dispatch(setSnackbar('Evidencia eliminada', 'success'))
    }).catch(error => {
      dispatch(setSnackbar(error))
    })
    dispatch(stopRequestComp('loadingComoData'))
  }
}


export const deleteComoData = (id) => {
  const url = `${process.env.REACT_APP_URL}/crm/commodatos/${id}`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingComoData'))

    await api_delete(url).then(resp => {
      dispatch({
        type: DELETE_COMO_DATA,
        payload: resp.id
      })
      dispatch(setSnackbar('Eliminado correctamente', 'success'))
    }).catch(error => {
      dispatch(setSnackbar(error))
    })
    dispatch(stopRequestComp('loadingComoData'))
  }
}

export const clearComoData = () => {
  return {
    type: CLEAR_COMO_DATA,
  }
}

export const setComoDataFilters = (key = "", data) => {
  return {
    type: SET_COMO_DATA_FILTERS,
    payload: { data, key }
  }
}

export const setConfigPageComoData = (page) => {
  return {
    type: SET_CONFIG_PAGE_COMO_DATA,
    payload: page,
  };
}

export const setConfigPageSizeComoData = (pageSize) => {
  return {
    type: SET_CONFIG_PAGE_SIZE_COMO_DATA,
    payload: pageSize,
  };
}

export const setConfigFilterComoData = (filter) => {
  return {
    type: SET_CONFIG_FILTER_COMO_DATA,
    payload: filter,
  };
}

export const setConfigSortedComoData = (sort) => {
  return {
    type: SET_CONFIG_SORTED_COMO_DATA,
    payload: sort,
  };
}